export default __webpack_public_path__ + "static/media/48_4_0.e56b34ce.png";